// HomeBanner.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { Loading } from "../Other/Loading";
import { useNavigate } from "react-router-dom";


const Homebanner = () => {
  const navigate = useNavigate();
  const [heroData, setHeroData] = useState(null);
  const { t, i18n } = useTranslation(); 

  
  useEffect(() => {
  const fetchData = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_LOGIN_API_BASEURL}/json-page/name/forbusiness`);
        //console.log("API Response:", response.data); // Log response to debug
        const events = JSON.parse(response.data);
        console.log(",,,,,,,,,,,,,API Response:", events);
        setHeroData(events);  // turns string into array of objects
      }
      catch (error) {
        console.error("Error fetching reasons data:", error);
      }
  };

  fetchData();
}, []);

  const scrollToForm = () => {
    const element = document.getElementById("lead-form");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  if (!heroData) return <p className="text-center text-gray-600"><Loading /></p>;

  return (
    <>
      <section
        className="mt-[70px] p-6 md:p-20 flex flex-col md:flex-row items-center h-[600px] justify-between w-full bg-white"
        style={{
          // backgroundImage: `url(${process.env.REACT_APP_SMIK_API_BASEURL}${heroData.image})`,
          backgroundImage: `url(${heroData.hero.image})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* Left Content */}
        <div className="md:w-1/2 w-full space-y-6 md:text-left text-center">
        
          <h1 className="text-3xl md:text-5xl font-bold text-[#006400] leading-tight">
            {(heroData.hero.heading && heroData.hero.highlightedText)
              ? heroData.hero.heading.replace(heroData.hero.highlightedText, "")
              : heroData.hero.heading || ""}
            <span> {heroData.hero.highlightedText || ""}</span>
          </h1>
          <h2 className="text-xl md:text-2xl font-semibold text-[#333333]">{heroData.hero.subheading}</h2>
          <p className="text-black max-w-xl">{heroData.hero.description}</p>

          {/* Buttons */}
          <div className="mt-6 flex gap-4 md:justify-start justify-center">
            {Array.isArray(heroData.hero.buttons) && heroData.hero.buttons.length > 0 ? (
              heroData.hero.buttons.map((btn, index) => (
                <button
                  key={index}
                  onClick={() => {
                    if (btn.link) {
                      navigate(btn.link);
                    } else {
                      scrollToForm();
                    }
                  }}
                  className={`px-8 py-3.5 text-lg font-bold rounded-xl transition-all duration-300 transform hover:scale-105 active:scale-95 shadow-lg hover:shadow-xl flex items-center justify-center ${
                    btn.primary
                      ? "bg-gradient-to-r from-blue-600 to-blue-700 text-white hover:from-blue-700 hover:to-blue-800"
                      : "bg-white/80 backdrop-blur-sm border-2 border-blue-600 text-blue-600 hover:bg-blue-50"
                  }`}
                >
                  {t(btn.text)}
                </button>
              ))
            ) : null}
          </div>
        </div>
      </section>


    </>
  );
};

export default Homebanner;

